import { PATHS, WAGES_AND_INCOME_SECTION_NAMES } from './constants';

export const CHOICE_NAMES = {
  CURRENT_JOB: 'choicesCurrentJob',
  ANTICIPATE_JOB_12_MONTHS: 'choicesAnticipateAJob12Months',
  JOB_LAST_90_DAYS: 'choicesJobLast90Days',
  ALIMONY_PAYMENTS: 'choicesAlimonyPayments',
  SSI: 'choicesSsi',
  CHILD_SUPPORT_ELIGIBLE: 'choicesChildSupportEligible',
  BENEFITS_SNAPS: 'choicesBenefitsSnaps',
  BENEFITS_DISABILITY: 'choicesBenefitsDisability',
  BENEFITS_PENSION: 'choicesBenefitsPension',
  BENEFITS_VA: 'choicesBenefitsVa',
  BENEFITS_FAMILY: 'choicesBenefitsFamily',
  PAYMENTS_ONLINE: 'choicesPaymentsOnline',
  PAYMENTS_TRUST: 'choicesPaymentsTrust',
  BENEFITS_RENTAL: 'choicesBenefitsRental',
  PAYMENTS_OTHER: 'choicesPaymentsOther',
};

const FORM_CHOICES_1 = {
  route: PATHS.CHOICES_1,
  options: [
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.job.current',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.CURRENT_JOBS,
      name: CHOICE_NAMES.CURRENT_JOB,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.job.next12Months',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.ANTICIPATED_JOBS,
      name: CHOICE_NAMES.ANTICIPATE_JOB_12_MONTHS,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.job.last90Days',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.LAST_JOBS,
      name: CHOICE_NAMES.JOB_LAST_90_DAYS,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.alimony.payments',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.ALIMONIES,
      name: CHOICE_NAMES.ALIMONY_PAYMENTS,
    },
  ],
};

const FORM_CHOICES_2 = {
  route: PATHS.CHOICES_2,
  options: [
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.alimony.ssi',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.SOCIAL_SECS,
      name: CHOICE_NAMES.SSI,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.childSupport.eligible',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.CHILD_SUPPORTS,
      name: CHOICE_NAMES.CHILD_SUPPORT_ELIGIBLE,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.snaps',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.PUBLIC_ASSISTANCES,
      name: CHOICE_NAMES.BENEFITS_SNAPS,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.disability',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.UNEMPLOYMENTS,
      name: CHOICE_NAMES.BENEFITS_DISABILITY,
    },
  ],
};

const FORM_CHOICES_3 = {
  route: PATHS.CHOICES_3,
  options: [
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.pension',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.PENSIONS,
      name: CHOICE_NAMES.BENEFITS_PENSION,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.va',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.VA_BENEFITS,
      name: CHOICE_NAMES.BENEFITS_VA,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.family',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.GIFTS,
      name: CHOICE_NAMES.BENEFITS_FAMILY,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.payments.online',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.ONLINES,
      name: CHOICE_NAMES.PAYMENTS_ONLINE,
    },
  ],
};

const FORM_CHOICES_4 = {
  route: PATHS.CHOICES_4,
  options: [
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.payments.trust',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.TRUSTS,
      name: CHOICE_NAMES.PAYMENTS_TRUST,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.benefits.rental',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.RENTAL_ASSISTANCE,
      name: CHOICE_NAMES.BENEFITS_RENTAL,
    },
    {
      label: {
        id: 'afforda.wagesAndIncome.choices.payments.other',
      },
      id: WAGES_AND_INCOME_SECTION_NAMES.OTHER_INCOMES,
      name: CHOICE_NAMES.PAYMENTS_OTHER,
    },
  ],
};

export const FORM_OPTIONS = [
  FORM_CHOICES_1,
  FORM_CHOICES_2,
  FORM_CHOICES_3,
  FORM_CHOICES_4,
];
